<template>
  <v-btn v-if="loading" loading small tile></v-btn>
  <RevealSample v-else-if="data" :sample_uuid="sample_uuid" :hidden="Boolean(data.hidden)" @refresh="getSample"></RevealSample>
</template>

<script>
export default {
    name: "CheckHidden",
    components: {
      RevealSample: () => import('@/views/HiddenReleases/components/RevealSample')
    },
    data: () => ({
      data: null,
      loading: true,
    }),
    props: {
      sample_uuid: {
        required: true,
        type: String,
      }
    },
    mounted(){
     this.getSample();
    },
    methods: {
      async getSample(){
        this.loading = true;
        let query = await this.$store.$db().model('reportedSamples').api().fetch({
          where: [{
            key: "uuid",
            value: this.sample_uuid
          }]
        }, '', null, false)
        console.log(query);
        if(query.response.data.length > 0){
          this.data = query.response.data[0];
        }
        this.loading = false;
      }
    }
}
</script>

<style scoped>

</style>
